// Get all the tooltip buttons
  const tooltipButtons = document.querySelectorAll('.callout-link');

  // Add event listener to each button
  tooltipButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Get the ID of the corresponding tooltip
      const tooltipId = button.getAttribute('aria-controls');

      // Get the tooltip element
      const tooltip = document.getElementById(tooltipId);

      // Toggle the display property of the tooltip
      tooltip.style.display = tooltip.style.display === 'none' ? 'block' : 'none';

      // Toggle the aria-expanded attribute of the button
      button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') === 'false' ? 'true' : 'false');
    });
  });

function slider() {
  $(".slider-prod").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

// Get the tab buttons and value spans
const tabButtons = document.querySelectorAll('.toggle-unit');
const valueSpans = document.querySelectorAll('.value');
const valueTds = document.querySelectorAll('td.value .value');


// Add click event listeners to tab buttons
tabButtons.forEach((button) => {
  button.addEventListener('click', () => {
    // Remove 'toggle-unit-active' class from all tab buttons
    tabButtons.forEach((button) => {
      button.classList.remove('toggle-unit-active');
    });
    // Add 'toggle-unit-active' class to clicked tab button
    button.classList.add('toggle-unit-active');

    // Toggle 'value-active' class on value spans
    if (button.id === 'tab1') {

      valueSpans[0].classList.add('value-active');
      valueSpans[1].classList.remove('value-active');
      valueSpans[2].classList.add('value-active');
      valueSpans[3].classList.remove('value-active');
      valueSpans[4].classList.add('value-active');
      valueSpans[5].classList.remove('value-active');
      valueSpans[6].classList.add('value-active');
      valueSpans[7].classList.remove('value-active');
      valueSpans[8].classList.add('value-active');
      valueSpans[9].classList.remove('value-active');
      valueSpans[10].classList.add('value-active');
      valueSpans[11].classList.remove('value-active');

      valueTds[0].classList.add('value-active');
      valueTds[1].classList.remove('value-active');
      valueTds[2].classList.add('value-active');
      valueTds[3].classList.remove('value-active');
      valueTds[4].classList.add('value-active');
      valueTds[5].classList.remove('value-active');
      valueTds[6].classList.add('value-active');
      valueTds[7].classList.remove('value-active');
      valueTds[8].classList.add('value-active');
      valueTds[9].classList.remove('value-active');
      valueTds[10].classList.add('value-active');
      valueTds[11].classList.remove('value-active');
      valueTds[12].classList.add('value-active');
      valueTds[13].classList.remove('value-active');
      valueTds[14].classList.add('value-active');
      valueTds[15].classList.remove('value-active');
      valueTds[16].classList.add('value-active');
      valueTds[17].classList.remove('value-active');
      
      valueTds[18].classList.add('value-active');
      valueTds[19].classList.remove('value-active');
      valueTds[20].classList.add('value-active');
      valueTds[21].classList.remove('value-active');
      valueTds[22].classList.add('value-active');
      valueTds[23].classList.remove('value-active');
      valueTds[24].classList.add('value-active');
      valueTds[25].classList.remove('value-active');
      valueTds[26].classList.add('value-active');
      valueTds[27].classList.remove('value-active');
      valueTds[28].classList.add('value-active');
      valueTds[29].classList.remove('value-active');
      valueTds[30].classList.add('value-active');
      valueTds[31].classList.remove('value-active');
      valueTds[32].classList.add('value-active');
      valueTds[33].classList.remove('value-active');
      valueTds[34].classList.add('value-active');
      valueTds[35].classList.remove('value-active');
      valueTds[36].classList.add('value-active');
      valueTds[37].classList.remove('value-active');
      valueTds[38].classList.add('value-active');
      valueTds[39].classList.remove('value-active');
      valueTds[40].classList.add('value-active');
      valueTds[41].classList.remove('value-active');
      valueTds[42].classList.add('value-active');
      valueTds[43].classList.remove('value-active');
      valueTds[44].classList.add('value-active');
      valueTds[45].classList.remove('value-active');
      valueTds[46].classList.add('value-active');
      valueTds[47].classList.remove('value-active');
      valueTds[48].classList.add('value-active');
      valueTds[49].classList.remove('value-active');

       valueTds[50].classList.add('value-active');
      valueTds[51].classList.remove('value-active');
      valueTds[52].classList.add('value-active');
      valueTds[53].classList.remove('value-active');
      valueTds[54].classList.add('value-active');
      valueTds[55].classList.remove('value-active');
      valueTds[56].classList.add('value-active');
      valueTds[57].classList.remove('value-active');
      valueTds[58].classList.add('value-active');
      valueTds[59].classList.remove('value-active');
      valueTds[60].classList.add('value-active');
      valueTds[61].classList.remove('value-active');
      valueTds[62].classList.add('value-active');
      valueTds[63].classList.remove('value-active');
      valueTds[64].classList.add('value-active');
      valueTds[65].classList.remove('value-active');
      valueTds[66].classList.add('value-active');
      valueTds[67].classList.remove('value-active');
      valueTds[68].classList.add('value-active');
      valueTds[69].classList.remove('value-active');
      valueTds[70].classList.add('value-active');
      valueTds[71].classList.remove('value-active');

      valueTds[72].classList.add('value-active');
      valueTds[73].classList.remove('value-active');
      valueTds[74].classList.add('value-active');
      valueTds[75].classList.remove('value-active');
      valueTds[76].classList.add('value-active');
      valueTds[77].classList.remove('value-active');
      valueTds[78].classList.add('value-active');
      valueTds[79].classList.remove('value-active');
      valueTds[80].classList.add('value-active');
      valueTds[81].classList.remove('value-active');
      valueTds[82].classList.add('value-active');
      valueTds[83].classList.remove('value-active');
      valueTds[84].classList.add('value-active');
      valueTds[85].classList.remove('value-active');
      valueTds[86].classList.add('value-active');
      valueTds[87].classList.remove('value-active');
      valueTds[88].classList.add('value-active');
      valueTds[89].classList.remove('value-active');
      valueTds[90].classList.add('value-active');
      valueTds[91].classList.remove('value-active');
      valueTds[92].classList.add('value-active');
      valueTds[93].classList.remove('value-active');
      valueTds[94].classList.add('value-active');
      valueTds[95].classList.remove('value-active');
      valueTds[96].classList.add('value-active');
      valueTds[97].classList.remove('value-active');
      valueTds[98].classList.add('value-active');
      valueTds[99].classList.remove('value-active');
      valueTds[100].classList.add('value-active');
      valueTds[101].classList.remove('value-active');
      valueTds[102].classList.add('value-active');
      valueTds[103].classList.remove('value-active');
      valueTds[104].classList.add('value-active');
      valueTds[105].classList.remove('value-active');

      valueTds[106].classList.add('value-active');
      valueTds[107].classList.remove('value-active');
      valueTds[108].classList.add('value-active');
      valueTds[109].classList.remove('value-active');
      valueTds[110].classList.add('value-active');
      valueTds[111].classList.remove('value-active');
      valueTds[112].classList.add('value-active');
      valueTds[113].classList.remove('value-active');
      valueTds[114].classList.add('value-active');
      valueTds[115].classList.remove('value-active');
      valueTds[116].classList.add('value-active');
      valueTds[117].classList.remove('value-active');
      valueTds[118].classList.add('value-active');
      valueTds[119].classList.remove('value-active');
      valueTds[120].classList.add('value-active');
      valueTds[121].classList.remove('value-active');
      valueTds[122].classList.add('value-active');
      valueTds[123].classList.remove('value-active');
      valueTds[124].classList.add('value-active');
      valueTds[125].classList.remove('value-active');
      valueTds[126].classList.add('value-active');
      valueTds[127].classList.remove('value-active');
      valueTds[128].classList.add('value-active');
      valueTds[129].classList.remove('value-active');

    } else if (button.id === 'tab2') {

      
      valueSpans[0].classList.remove('value-active');
      valueSpans[1].classList.add('value-active');
      valueSpans[2].classList.remove('value-active');
      valueSpans[3].classList.add('value-active');
      valueSpans[4].classList.remove('value-active');
      valueSpans[5].classList.add('value-active');
      valueSpans[6].classList.remove('value-active');
      valueSpans[7].classList.add('value-active');
      valueSpans[8].classList.remove('value-active');
      valueSpans[9].classList.add('value-active');
      valueSpans[10].classList.remove('value-active');
      valueSpans[11].classList.add('value-active');

      valueTds[0].classList.remove('value-active');
      valueTds[1].classList.add('value-active');
      valueTds[2].classList.remove('value-active');
      valueTds[3].classList.add('value-active');
      valueTds[4].classList.remove('value-active');
      valueTds[5].classList.add('value-active');
      valueTds[6].classList.remove('value-active');
      valueTds[7].classList.add('value-active');
      valueTds[8].classList.remove('value-active');
      valueTds[9].classList.add('value-active');
      valueTds[10].classList.remove('value-active');
      valueTds[11].classList.add('value-active');
      valueTds[12].classList.remove('value-active');
      valueTds[13].classList.add('value-active');
      valueTds[14].classList.remove('value-active');
      valueTds[15].classList.add('value-active');
      valueTds[16].classList.remove('value-active');
      valueTds[17].classList.add('value-active');

       valueTds[18].classList.remove('value-active');
      valueTds[19].classList.add('value-active');
       valueTds[20].classList.remove('value-active');
      valueTds[21].classList.add('value-active');
       valueTds[22].classList.remove('value-active');
      valueTds[23].classList.add('value-active');
       valueTds[24].classList.remove('value-active');
      valueTds[25].classList.add('value-active');
       valueTds[26].classList.remove('value-active');
      valueTds[27].classList.add('value-active');
       valueTds[28].classList.remove('value-active');
      valueTds[29].classList.add('value-active');
       valueTds[30].classList.remove('value-active');
      valueTds[31].classList.add('value-active');
       valueTds[32].classList.remove('value-active');
      valueTds[33].classList.add('value-active');
       valueTds[34].classList.remove('value-active');
      valueTds[35].classList.add('value-active');
       valueTds[36].classList.remove('value-active');
      valueTds[37].classList.add('value-active');
       valueTds[38].classList.remove('value-active');
      valueTds[39].classList.add('value-active');
       valueTds[40].classList.remove('value-active');
      valueTds[41].classList.add('value-active');
       valueTds[42].classList.remove('value-active');
      valueTds[43].classList.add('value-active');
       valueTds[44].classList.remove('value-active');
      valueTds[45].classList.add('value-active');
       valueTds[46].classList.remove('value-active');
      valueTds[47].classList.add('value-active');
       valueTds[48].classList.remove('value-active');
      valueTds[49].classList.add('value-active');

valueTds[50].classList.remove('value-active');
      valueTds[51].classList.add('value-active');
      valueTds[52].classList.remove('value-active');
      valueTds[53].classList.add('value-active');
      valueTds[54].classList.remove('value-active');
      valueTds[55].classList.add('value-active');
      valueTds[56].classList.remove('value-active');
      valueTds[57].classList.add('value-active');
      valueTds[58].classList.remove('value-active');
      valueTds[59].classList.add('value-active');
       valueTds[60].classList.remove('value-active');
      valueTds[61].classList.add('value-active');
       valueTds[62].classList.remove('value-active');
      valueTds[63].classList.add('value-active');
       valueTds[64].classList.remove('value-active');
      valueTds[65].classList.add('value-active');
       valueTds[66].classList.remove('value-active');
      valueTds[67].classList.add('value-active');
       valueTds[68].classList.remove('value-active');
      valueTds[69].classList.add('value-active');
       valueTds[70].classList.remove('value-active');
      valueTds[71].classList.add('value-active');

      valueTds[72].classList.remove('value-active');
      valueTds[73].classList.add('value-active');
      valueTds[74].classList.remove('value-active');
      valueTds[75].classList.add('value-active');
      valueTds[76].classList.remove('value-active');
      valueTds[77].classList.add('value-active');
      valueTds[78].classList.remove('value-active');
      valueTds[79].classList.add('value-active');
      valueTds[80].classList.remove('value-active');
      valueTds[81].classList.add('value-active');
      valueTds[82].classList.remove('value-active');
      valueTds[83].classList.add('value-active');
      valueTds[84].classList.remove('value-active');
      valueTds[85].classList.add('value-active');
      valueTds[86].classList.remove('value-active');
      valueTds[87].classList.add('value-active');
      valueTds[88].classList.remove('value-active');
      valueTds[89].classList.add('value-active');
      valueTds[90].classList.remove('value-active');
      valueTds[91].classList.add('value-active');
      valueTds[92].classList.remove('value-active');
      valueTds[93].classList.add('value-active');
      valueTds[94].classList.remove('value-active');
      valueTds[95].classList.add('value-active');
      valueTds[96].classList.remove('value-active');
      valueTds[97].classList.add('value-active');
      valueTds[98].classList.remove('value-active');
      valueTds[99].classList.add('value-active');
      valueTds[100].classList.remove('value-active');
      valueTds[101].classList.add('value-active');
      valueTds[102].classList.remove('value-active');
      valueTds[103].classList.add('value-active');
      valueTds[104].classList.remove('value-active');
      valueTds[105].classList.add('value-active');

      valueTds[106].classList.remove('value-active');
      valueTds[107].classList.add('value-active');
      valueTds[108].classList.remove('value-active');
      valueTds[109].classList.add('value-active');
      valueTds[110].classList.remove('value-active');
      valueTds[111].classList.add('value-active');
      valueTds[112].classList.remove('value-active');
      valueTds[113].classList.add('value-active');
      valueTds[114].classList.remove('value-active');
      valueTds[115].classList.add('value-active');
      valueTds[116].classList.remove('value-active');
      valueTds[117].classList.add('value-active');
      valueTds[118].classList.remove('value-active');
      valueTds[119].classList.add('value-active');
      valueTds[120].classList.remove('value-active');
      valueTds[121].classList.add('value-active');
      valueTds[122].classList.remove('value-active');
      valueTds[123].classList.add('value-active');
      valueTds[124].classList.remove('value-active');
      valueTds[125].classList.add('value-active');
      valueTds[126].classList.remove('value-active');
      valueTds[127].classList.add('value-active');
      valueTds[128].classList.remove('value-active');
      valueTds[129].classList.add('value-active');

    }
  });
});

function menu(){
 const menu = document.querySelector('.mobileMenu-toggle');
const body = document.querySelector('body');
const search = document.querySelector('.header-mobile__item--search');
const cl = document.querySelectorAll('.halo-sidebar-close');

menu.addEventListener('click', () => {
  body.classList.add('menu_open');
});

search.addEventListener('click', () => {
  body.classList.add('open_search_mobile');
});

cl.forEach((element) => {
  element.addEventListener('click', () => {
    if (body.classList.contains('open_search_mobile')) {
      body.classList.remove('open_search_mobile');
    }

    if (body.classList.contains('menu_open')) {
      body.classList.remove('menu_open');
    }
  });
});

}

// var swiper=new Swiper('#swiper-30739',{direction:'horizontal',slidesPerView:1,navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev",},pagination:{el:".swiper-pagination",clickable:true},});
// var swiper=new Swiper('#swiper-34547',{direction:'horizontal',slidesPerView:1,navigation:{nextEl:".swiper-button-next",prevEl:".swiper-button-prev",},pagination:{el:".swiper-pagination",clickable:true},});
 function hostPoint(){
    console.log(document.querySelectorAll(".hotspot-btn")) 
    document.querySelectorAll(".hotspot-btn").forEach(function(button)  {
        button.addEventListener("click", function() {
          document.querySelectorAll(".hotspot-info").forEach(function(info) {
                info.style.display = "none";
            });
            
            let hotspotId = this.getAttribute("data-hotspot-id");
            let hotspotInfo = document.getElementById(hotspotId);
            hotspotInfo.style.display = "block";
        });
    });
    
    document.addEventListener("click", function(event) {
        if (!event.target.classList.contains("hotspot-btn")) {
            document.querySelectorAll(".hotspot-info").forEach(function(info) {
                info.style.display = "none";
            });
        }
    });
}
function openPopup(){
let btnguia = document.querySelectorAll('.btnguia');
  if(btnguia.length > 0){
    console.log('btn' + btnguia)
     btnguia.forEach((button) => {
    button.addEventListener('click', () => {
      console.log(button);
      const overlay = document.getElementById('overlayModalSize');
            const popup = document.getElementById('popup');
            overlay.style.display = 'block';
            setTimeout(() => {
                popup.classList.add('active');
            }, 10);    
    })
  })
  }
 
        
    }
     function hidePopup() {
            const overlay = document.getElementById('overlayModalSize');
            const popup = document.getElementById('popup');
            popup.classList.remove('active');
            setTimeout(() => {
                overlay.style.display = 'none';
            }, 300);
        }

function Error404(){

  let url = window.location.href;
  console.log(url);
  async (url) => {
    try{
      if(!response.ok){
        if(response.status === 404){
          window.location.href="https://giant-bicycles.cl/"
          return true;
        }
      }
    }
    catch(error){
      return false;
    }
  }
}
$(document).ready(function() {
  menu();
  Error404();
  openPopup()
  hostPoint();
  slider();
    let elementos = $(".template-product");
    if(elementos.length == 1){
      let vw  = window.innerWidth;
      if(vw >= 1080){
        function ImgAj(img){
          
        
          let Wo = img.naturalWidth;
          let Ho = img.naturalHeight;
          if(Wo > 1080){
            let ratio = 1080 / Ho;
            let x = ratio * 450
              // También puedes cambiar atributos o realizar otras operaciones con cada imagen
            img.style.width = '1080px';
          }else{
            img.style.width = '1080px';
          }
        }
      }
      
    }
  let oferta = document.querySelectorAll('.no-megamenu');
  oferta[0].classList.add('colorOferta')

  let img = document.querySelectorAll(".productView-img-container.product-single__media img");
  img.forEach(function(img) {
    ImgAj(img);
  })

  if(window.location.href == "https://giant-bicycles.cl/pages/financiamiento-bicicletas"){
    let mainElement = document.querySelector("main");

    // Verificar que el elemento <main> existe
    if (mainElement) {
        // Obtener todos los elementos <button> dentro de <main>
        let buttons = mainElement.getElementsByTagName("a");

        // Iterar sobre cada botón y agregar el atributo target="_blank"
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].setAttribute("target", "_blank");
        }
    }
  }
})

